import { Injectable, signal } from '@angular/core';

export type ToastKind = 'info' | 'success' | 'warning' | 'danger';

export interface Toast {
  id: number;
  kind: ToastKind;
  message: string;
}

/**
 * Notificações efêmeras do design system (usadas p.ex. no 403 "Sem permissão").
 * Zoneless-friendly: agenda a remoção sem depender de zone.js.
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  private seq = 0;
  private readonly _toasts = signal<Toast[]>([]);
  readonly toasts = this._toasts.asReadonly();

  show(message: string, kind: ToastKind = 'info', durationMs = 4000): void {
    const id = ++this.seq;
    this._toasts.update((list) => [...list, { id, kind, message }]);
    setTimeout(() => this.dismiss(id), durationMs);
  }

  info(message: string) {
    this.show(message, 'info');
  }
  success(message: string) {
    this.show(message, 'success');
  }
  warning(message: string) {
    this.show(message, 'warning');
  }
  danger(message: string) {
    this.show(message, 'danger');
  }

  dismiss(id: number): void {
    this._toasts.update((list) => list.filter((t) => t.id !== id));
  }
}
